import { render, staticRenderFns } from "./createResp.vue?vue&type=template&id=11c330c0&scoped=true"
import script from "./createResp.vue?vue&type=script&lang=js"
export * from "./createResp.vue?vue&type=script&lang=js"
import style0 from "./createResp.vue?vue&type=style&index=0&id=11c330c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c330c0",
  null
  
)

export default component.exports